import { DocList } from "../DocList";

/** Who else handles the data, how long it is kept and how it is protected. */
export function PersonalDataCare(): React.JSX.Element {
  return (
    <>
      <h3>Who else handles your data</h3>
      <DocList>
        <li>
          Cloudflare, which carries and protects the suite&apos;s network traffic. It is based in the United States, so this is an
          international transfer, covered by its data processing terms with standard contractual clauses.
        </li>
        <li>The company that hosts the suite&apos;s servers.</li>
        <li>
          turboSMTP (servers in the European Economic Area, company in the United States and Italy) sends
          the suite&apos;s emails, under its data processing agreement. It keeps delivery records for up to 12
          months.
        </li>
      </DocList>
      <p>Nothing else is shared with anyone, unless the law requires it.</p>

      <h3>How long we keep it</h3>
      <DocList>
        <li>Your account data, for as long as your account exists.</li>
        <li>The audit trail, for the period set in the suite&apos;s retention policy, and never less than one year.</li>
        <li>Technical logs, for the period set in the log policy.</li>
        <li>Backups, for the period set in the backup policy.</li>
        <li>When an account is deleted, its personal data is anonymized: the records stay, but no longer say who you are.</li>
      </DocList>

      <h3>How we protect it</h3>
      <DocList>
        <li>Every connection is encrypted.</li>
        <li>Two-step verification is mandatory for everyone.</li>
        <li>Sensitive data is encrypted where it is stored.</li>
        <li>Each person gets only the access their role needs.</li>
        <li>Important actions are recorded in the audit trail.</li>
        <li>Backups are encrypted.</li>
      </DocList>
    </>
  );
}
